// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"263":"4d0441f1","354":"2372b6b7","864":"d74fd435"}[chunkId] + ".css";
};